import React, { useEffect, useState } from 'react';
import { adminAPI } from '../../../services/authService';
import { notifyError } from '../../../utils/notify';

const ConfigFieldLibrary = () => {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState('');
  const [fieldClass, setFieldClass] = useState('');
  const [status, setStatus] = useState('');

  const load = () => {
    const params = {};
    if (q) params.q = q;
    if (fieldClass) params.fieldClass = fieldClass;
    if (status) params.status = status;
    adminAPI.getConfigFields(params)
      .then((res) => setRows(res?.data?.data || res?.data || []))
      .catch(() => notifyError('Unable to load field library'));
  };

  useEffect(() => { load(); }, []); // eslint-disable-line

  return (
    <div>
      <div className="filter-bar">
        <input placeholder="Search key / label" value={q} onChange={(e) => setQ(e.target.value)} />
        <select value={fieldClass} onChange={(e) => setFieldClass(e.target.value)}>
          <option value="">All classes</option>
          <option value="CORE_SYSTEM">CORE_SYSTEM</option>
          <option value="STANDARD_CONFIGURABLE">STANDARD_CONFIGURABLE</option>
          <option value="CUSTOM">CUSTOM</option>
          <option value="COMPUTED">COMPUTED</option>
        </select>
        <select value={status} onChange={(e) => setStatus(e.target.value)}>
          <option value="">All statuses</option>
          <option value="ACTIVE">ACTIVE</option>
          <option value="INACTIVE">INACTIVE</option>
          <option value="DRAFT">DRAFT</option>
          <option value="ARCHIVED">ARCHIVED</option>
        </select>
        <button type="button" className="btn-primary" onClick={load}>Apply</button>
      </div>
      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>Module</th><th>Page</th><th>Form</th><th>Key</th><th>Label</th>
              <th>Type</th><th>Class</th><th>Required</th><th>Status</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr><td colSpan={9} style={{ textAlign: 'center', color: '#64748b', padding: 24 }}>No fields</td></tr>
            ) : rows.map((f) => (
              <tr key={f.id}>
                <td>{f.form?.page?.moduleKey}</td>
                <td>{f.form?.page?.displayName}</td>
                <td>{f.form?.displayName || f.formId}</td>
                <td><code>{f.fieldKey}</code></td>
                <td>{f.label}</td>
                <td>{f.fieldType}</td>
                <td><span className={`ce-badge ${f.fieldClass === 'CORE_SYSTEM' ? 'ce-badge--warn' : 'ce-badge--ok'}`}>{f.fieldClass}</span></td>
                <td>{f.required ? 'Yes' : '—'}</td>
                <td>{f.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ConfigFieldLibrary;
